<template>
  <div class="schedule__no-results">
    <div class="schedule__no-results-message-box">
      <ResultCounter :count="0" />
      <p class="wb-type-copy">
        {{ $t('schedule.noResults.subTitle') }}
      </p>
    </div>
    <wb-notification
      v-if="noDealersFound"
      icon="alert-circle"
      theme="dark"
      mode="warning"
      class="wb-margin-bottom-s schedule__no-results-notification"
      hide-dismiss-button
    >
      <wb-notification-content>
        {{ $t('schedule.noDealers.notification') }}
      </wb-notification-content>
    </wb-notification>
    <wb-card
      class="schedule__no-results-submit-request-box"
      :class="noDealersFoundClass"
    >
      <h3 class="wb-type-copy-strong">
        {{ $t('schedule.request.box.title') }}
      </h3>
      <div class="schedule__no-results-request-message-box">
        <wb-icon name="bds/info-circle/24"></wb-icon>
        <h4
          class="schedule__no-results-request-message-box__title wb-type-copy-secondary"
        >
          {{ $t('schedule.request.box.info.title') }}
        </h4>
        <p
          class="schedule__no-results-request-message-box__text wb-type-copy-secondary"
        >
          {{ $t('schedule.request.box.info.text') }}
        </p>
      </div>
      <button
        type="button"
        class="wb-button wb-button--primary wb-button--small"
        @click="proceedWithRequest()"
      >
        {{ $t('schedule.request.box.cta') }}
      </button>
    </wb-card>
  </div>
</template>

<script lang="ts">
import { useFilters } from '@dh-io-otb/otbc/src/composables/filters.composable';
import { defineComponent, computed } from 'vue';

import { ResultCounter } from '../index';

export default defineComponent({
  name: 'otb-schedule-no-results',
  components: {
    ResultCounter,
  },
  props: {
    goToRequestPage: Function as any,
    setSingleOptionFiltersAsSelected: Function as any,
    noDealersFound: Boolean,
  },
  setup(props) {
    const { resetAllVehicleFiltersInRequest } = useFilters();

    const proceedWithRequest = async () => {
      props.goToRequestPage();
      resetAllVehicleFiltersInRequest();
      props.setSingleOptionFiltersAsSelected();
    };

    const noDealersFoundClass = computed(() => {
      return {
        'schedule__no-results-submit-request-box__no-dealers':
          props.noDealersFound,
      };
    });

    return {
      proceedWithRequest,
      noDealersFoundClass,
    };
  },
});
</script>
<style src="./schedule-no-results.scss" lang="scss"></style>
